import BackgroundLayer from "@/components/BackgroundLayer";
import RadioGroup from "@/components/RadioGroup";
import { ListenButton } from "@/components/AudioControls";

const EVENT_OPTIONS = [
  { value: "A", label: "Hold. My long-term thesis hasn't changed." },
  { value: "B", label: "Reduce my allocation in risky assets by 10–15%. Get more defensive." },
  { value: "C", label: "Move a meaningful portion to cash or safety assets. Protect what I have." },
  { value: "D", label: "Actually increase my allocation in risky assets. Prices are lower now." },
  { value: "E", label: "My advisor would have a recommendation for this." },
];

export default function MarketEvent3({ sessionData, updateSession, onNext, onBack, stageIndex }) {
  return (
    <div className="page-wrapper" data-testid="market-event3-page">
      <BackgroundLayer image="/images/page5_bg_event3.jpg" />
      <div className="content-layer" style={{ minHeight: "100vh", minHeight: "100dvh" }}>
        <div className="page-content" style={{ paddingTop: 60, paddingBottom: 80 }}>
          <div className="section-label animate-in" style={{ marginBottom: 12 }}>02: The Market Moves</div>
          <div className="animate-in animate-in-d1" style={{ marginBottom: 20 }}>
            <ListenButton stageIndex={stageIndex} />
          </div>

          <div className="section-text-block">
            <h2 className="section-heading animate-in animate-in-d1" style={{ marginBottom: 20 }}>
              Event 3 — March 2009:
            </h2>
            <p className="standout-line animate-in animate-in-d2" style={{ marginBottom: 4 }}>
              The S&P 500 hits its lowest point.
            </p>
            <p className="body-text animate-in animate-in-d2">
              Down 56.8% from its October 2007 peak.
            </p>
            <p className="body-text animate-in animate-in-d3">
              Every major financial institution has been bailed out, collapsed, or acquired.
            </p>
            <p className="body-text animate-in animate-in-d3">
              Your portfolio, depending on your choices, is down significantly.
            </p>

            <p className="standout-line animate-in animate-in-d5" style={{ marginTop: 28, marginBottom: 12 }}>
              What's your call for the moment?
            </p>
          </div>

          <div className="animate-in animate-in-d6">
            <RadioGroup
              name="e3"
              options={EVENT_OPTIONS}
              selected={sessionData.e3}
              onSelect={(v) => updateSession("e3", v)}
            />
          </div>

          <div className="nav-buttons animate-in animate-in-d7">
            <button className="nav-back" onClick={onBack} data-testid="back-btn">Back</button>
            <button
              className="cta-pill"
              onClick={onNext}
              disabled={!sessionData.e3}
              data-testid="next-btn"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
